



















import { Picker, Popup, Icon } from 'vant';
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import { RequestState } from "@/network/http";
import { AreaInfo, defaultCity } from '@/data/local/common'
import { getModule } from 'vuex-module-decorators';
import { getCity, setCity } from "@/utils/index";
import CommonStore from '@/store/modules/common';

const commonModule = getModule(CommonStore);

interface AreaItem {
    id: number;
    text: string;
    children?: AreaItem[];
}

Vue.use(Picker);
Vue.use(Popup);
Vue.use(Icon);

@Component({})
export default class CitySelector extends Vue {
    @Prop(Number)
    type: number;
    @Prop(Number)
    cityId?: number; //默认
    @Prop(Boolean)
    store?: boolean;

    allAreas: AreaInfo[] = [];
    city: AreaInfo = defaultCity;
    showSelector: boolean = false;


    created() {
  
    }

    mounted() {
        let city: AreaInfo = this.getDefautCity();
        this.city = city;
        this.onSelectCity(city);
    }

    getDefautCity(): AreaInfo {
        if (this.cityId && this.cityId > 0) {
            //父主键有传默认显示的城市ID
            let citys: AreaInfo[] = commonModule.getAreas;
            if (citys) {
                for (let n = 0; n < citys.length; n++) {
                    if (citys[n].childrens) {
                        for (let m = 0; m < citys[n].childrens.length; m++) {
                            if (this.cityId === citys[n].childrens[m].id) {
                                return citys[n].childrens[m];
                            }
                        }
                    }
                }
            }
        }

        return getCity();
    }

    get allCitys() {
        let citys: AreaItem[] = [];
        let allAreas: AreaInfo[] = commonModule.getAreas;

        if (allAreas) {
            this.allAreas = allAreas;

            allAreas.forEach(item => {
                let areaItem: AreaItem = {
                    id: item.id,
                    text: item.name
                };

                let children: AreaItem[] = [];
                if (item.childrens) {
                    item.childrens.forEach(childrenItem => {
                        children.push({
                            id: childrenItem.id,
                            text: childrenItem.name
                        });
                    });
                }
                areaItem.children = children;
                citys.push(areaItem);
            });
        }
        
        return citys;
    }

    onSelect() {
        this.showSelector = true;
    }

    onConfirm(values: string[], indexs: number[]) {
        if (indexs && indexs.length === 2 && values && this.allAreas.length > indexs[0]) {
            let city: AreaInfo = this.allAreas[indexs[0]].childrens[indexs[1]];
            this.city = city
            if (this.store) {
                setCity(city);
            }
            this.onSelectCity(city);
        }
        
        this.showSelector = false;
        
    }

    onCancel(value: any) {
        this.showSelector = false;
    }

    @Emit("onSelectCity") 
    private onSelectCity(city: AreaInfo): AreaInfo {
        return city
    }
}

